module.exports = __webpack_public_path__ + "cfeb162b0532eedaf61ce3c8ded7722f.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fontello/fontello.eot?67495670
// module id = 451
// module chunks = 0